import React from 'react';
import { IonButtons, IonContent, IonFooter, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';

import { withLogin } from 'pages/hocs/withLogin';
import { BackButton } from 'components/common/buttons/BackButton';
import { NoDataMessage } from 'components/common/NoDataMessage';
import { TabBar, TabMenu } from 'components/common/TabBar';

interface NoDataPageOptions {
  title: string;
  // タブのトップ画面の場合に指定する
  tab?: TabMenu;
  // 下層画面の場合に指定する戻り先
  backHref?: string;
}

/**
 * サービス終了に伴い、案件リスト以外のデータ画面は「まだデータがありません」とだけ表示する。
 */
export const createNoDataPage = ({ title, tab, backHref }: NoDataPageOptions): React.FC =>
  withLogin(() => (
    <IonPage>
      <IonHeader mode="ios">
        <IonToolbar mode="ios">
          {backHref ? (
            <IonButtons className="header">
              <BackButton defaultHref={backHref} />
              <IonTitle>{title}</IonTitle>
            </IonButtons>
          ) : (
            <IonTitle>{title}</IonTitle>
          )}
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <NoDataMessage message="まだデータがありません" />
      </IonContent>
      {tab && (
        <IonFooter>
          <TabBar selectedTab={tab} />
        </IonFooter>
      )}
    </IonPage>
  ));
